<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <!-- Top bar -->
      <div class="row align-items-center mb-4">
        <div
          class="d-md-flex d-sm-block justify-content-between align-items-center flex-wrap"
        >
          <h6 class="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
            <router-link to="/projects/projects-list">
              <i class="ti ti-arrow-left me-2"></i>
              Back to List
            </router-link>
          </h6>

          <div class="d-flex dq-page-actions">
            <div class="text-end">
              <a
                href="javascript:void(0);"
                class="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#add_project"
              >
                <i class="ti ti-edit me-1"></i>Edit Project
              </a>
            </div>
            <div class="head-icons ms-2 text-end">
              <a
                href="javascript:void(0);"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-original-title="Collapse"
                id="collapse-header"
                @click="toggleHeader"
              >
                <i class="ti ti-chevrons-up"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div v-if="loadingProject" class="text-center py-5">
        <span class="spinner-border mb-3"></span>
        <p class="mb-0">Loading project...</p>
      </div>

      <div v-else-if="!project" class="text-center py-5">
        <p class="mb-0 text-muted">Project not found.</p>
      </div>

      <div v-else class="row">
        <!-- LEFT SIDEBAR -->
        <div class="col-xxl-3 col-xl-4 theiaStickySidebar">
          <div class="card">
            <div class="card-body">
              <h5 class="mb-3">Project Details</h5>

              <div class="list-group details-list-group mb-4">
                <div class="list-group-item">
                  <span>Client</span>
                  <div class="text-end">
                    <router-link
                      v-if="project.client_id"
                      :to="{ name: 'crm.clients.details', params: { id: project.client_id } }"
                      class="text-primary fw-medium"
                    >
                      {{ project.client_name || "N/A" }}
                    </router-link>
                    <p v-else class="text-gray-9 mb-0">
                      {{ project.client_name || "N/A" }}
                    </p>
                  </div>
                </div>

                <div class="list-group-item">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <span>Project Total Cost</span>
                    <p class="text-gray-9 mb-0">
                      {{ valueDisplay }}
                    </p>
                  </div>
                </div>

                <div class="list-group-item">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <span>Hours of Work</span>
                    <p class="text-gray-9 mb-0">
                      {{ hoursDisplay }}
                    </p>
                  </div>
                </div>

                <div class="list-group-item">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <span>Created on</span>
                    <p class="text-gray-9 mb-0">
                      {{ formatDate(project.created_at) }}
                    </p>
                  </div>
                </div>

                <div class="list-group-item">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <span>Started on</span>
                    <p class="text-gray-9 mb-0">
                      {{ formatDate(project.start_date) }}
                    </p>
                  </div>
                </div>

                <div class="list-group-item">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <span>Due Date</span>
                    <div class="d-flex align-items-center">
                      <p class="text-gray-9 mb-0">
                        {{ formatDate(project.end_date) }}
                      </p>
                      <span
                        v-if="isOverdue"
                        class="badge badge-danger d-inline-flex align-items-center ms-2"
                      >
                        <i class="ti ti-clock-stop me-1"></i>{{ overdueDays }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="list-group-item">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <span>Leader</span>
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-sm avatar-rounded me-2">
                        <img
                          v-if="project.leader_avatar"
                          :src="project.leader_avatar"
                          alt="Leader"
                        />
                        <img
                          v-else
                          src="@/assets/img/users/user-01.jpg"
                          alt="Leader"
                        />
                      </span>
                      <p class="text-gray-9 mb-0">
                        {{ project.leader_name || "Unassigned" }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="list-group-item">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <span>Priority</span>
                    <div class="dropdown">
                      <a
                        href="javascript:void(0);"
                        class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        <span
                          class="rounded-circle d-flex justify-content-center align-items-center me-2"
                          :class="priorityBgClass"
                        >
                          <i
                            class="ti ti-point-filled"
                            :class="priorityDotClass"
                          ></i>
                        </span>
                        {{ project.priority }}
                      </a>
                    
                    </div>
                  </div>
                </div>
              </div>

              <h5 class="mb-3">Tasks Details</h5>
              <div class="bg-light p-2 rounded">
                <span class="d-block mb-1">Tasks Done</span>
                <h4 class="mb-2">
                  {{ taskStats.completed }} / {{ taskStats.total }}
                </h4>
                <div class="progress progress-xs mb-2">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    :style="{ width: taskStats.percent + '%' }"
                  ></div>
                </div>
                <p class="mb-0">{{ taskStats.percent }}% Completed</p>
              </div>
            </div>
          </div>
        </div>

        <!-- MAIN CONTENT -->
        <div class="col-xxl-9 col-xl-8">
          <div class="card">
            <div class="card-body">
              <!-- Header strip -->
              <div class="bg-light rounded p-3 mb-3">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 me-2">
                    <img src="@/assets/img/social/project-01.svg" alt="Img" />
                  </div>
                  <div>
                    <h6 class="mb-1">
                      {{ project.name }}
                    </h6>
                    <p class="mb-0">
                      Project ID :
                      <span class="text-primary">
                        {{ project.project_code || "N/A" }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div class="row align-items-center">
                <!-- Status -->
                <div class="col-sm-3">
                  <p class="d-flex align-items-center mb-3">
                    <i class="ti ti-square-rounded me-2"></i>Status
                  </p>
                </div>
                <div class="col-sm-9">
                  <span
                    class="badge d-inline-flex align-items-center mb-3"
                    :class="statusBadgeClass"
                  >
                    <i class="ti ti-point-filled me-1"></i>{{ project.status }}
                  </span>
                </div>

                <!-- Team -->
                <div class="col-sm-3">
                  <p class="d-flex align-items-center mb-3">
                    <i class="ti ti-users-group me-2"></i>Team
                  </p>
                </div>
                <div class="col-sm-9">
                  <div class="d-flex align-items-center mb-3 flex-wrap">
                    <div
                                  class="avatar-list-stacked avatar-group-sm"
                                >
                                  <span
                                    v-for="(av, i) in project.team_avatars"
                                    :key="i"
                                    class="avatar avatar-rounded"
                                  >
                                    <img
                                      class="border border-white"
                                      :src="
                                        av ||
                                        require('@/assets/img/profiles/avatar-13.jpg')
                                      "
                                      alt="img"
                                    />
                                  </span>
                                </div>

                    <div v-if="project.extra_team_count" class="mb-2">
                      <span class="badge bg-primary text-white rounded-pill">
                        +{{ project.extra_team_count }} more
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Leader (as Team Lead) -->
                <div class="col-sm-3">
                  <p class="d-flex align-items-center mb-3">
                    <i class="ti ti-user-shield me-2"></i>Team Lead
                  </p>
                </div>
                <div class="col-sm-9">
                  <div class="d-flex align-items-center mb-3">
                    <div
                      class="bg-gray-100 p-1 rounded d-flex align-items-center me-2"
                    >
                      <a
                        href="javascript:void(0);"
                        class="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2"
                      >
                        <img
                          v-if="project.leader_avatar"
                          :src="project.leader_avatar"
                          alt="Leader"
                        />
                        <img
                          v-else
                          src="@/assets/img/users/user-01.jpg"
                          alt="Leader"
                        />
                      </a>
                      <h6 class="fs-12 mb-0">
                        <a href="javascript:void(0);">
                          {{ project.leader_name || "Unassigned" }}
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>

                <!-- Tags (placeholder for future dynamic tags) -->
                <div class="col-sm-3">
                  <p class="d-flex align-items-center mb-3">
                    <i class="ti ti-bookmark me-2"></i>Tags
                  </p>
                </div>
                <div class="col-sm-9">
                  <div class="d-flex align-items-center mb-3">
                    <span class="badge bg-light rounded-pill text-muted">
                      No tags
                    </span>
                  </div>
                </div>

                <!-- Description -->
                <div class="col-sm-12">
                  <div class="mb-3">
                    <h6 class="mb-1">Description</h6>
                    <div
                      v-if="project.description"
                      class="project-description"
                      v-html="project.description"
                    ></div>
                    <p v-else class="text-muted mb-0">
                      No description provided.
                    </p>
                  </div>
                </div>

                <!-- Time Spent -->
                <div class="col-md-12">
                  <div
                    class="bg-soft-secondary p-3 rounded d-flex align-items-center justify-content-between"
                  >
                    <p class="text-secondary mb-0">
                      Time Spent on this project
                    </p>
                    <h3 class="text-secondary mb-0">
                      {{ timeSpentLabel }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ACCORDIONS -->
          <div class="custom-accordion-items">
            <div
              class="accordion accordions-items-seperate"
              id="accordionExample"
            >
              <!-- TASKS ACCORDION (dynamic) -->
              <div class="accordion-item">
                <div class="accordion-header" id="headingTasks">
                  <div class="accordion-button">
                    <h5>Tasks</h5>
                    <div class="ms-auto">
                      <a
                        href="javascript:void(0);"
                        class="d-flex align-items-center collapsed collapse-arrow"
                        data-bs-toggle="collapse"
                        data-bs-target="#tasksCollapse"
                        aria-expanded="true"
                        aria-controls="tasksCollapse"
                      >
                        <i class="ti ti-chevron-down fs-18"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  id="tasksCollapse"
                  class="accordion-collapse collapse show border-top"
                  aria-labelledby="headingTasks"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <div
                      v-if="tasks.length"
                      class="list-group list-group-flush"
                    >
                      <div
                        v-for="t in tasks"
                        :key="t.id"
                        class="list-group-item border rounded mb-2 p-2"
                      >
                        <div class="row align-items-center row-gap-3">
                          <div class="col-md-7">
                            <div
                              class="d-flex align-items-center flex-wrap row-gap-3"
                            >
                              <span><i class="ti ti-grid-dots me-2"></i></span>
                              <div class="form-check form-check-md me-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  :checked="t.status === 'Completed'"
                                  disabled
                                />
                              </div>
                              <span
                                class="me-2 rating-select d-flex align-items-center"
                              >
                                <i
                                  class="ti"
                                  :class="
                                    t.priority === 'High'
                                      ? 'ti-star-filled filled'
                                      : 'ti-star'
                                  "
                                ></i>
                              </span>
                              <div class="strike-info">
                                <h4 class="fs-14 mb-0">
                                  {{ t.title }}
                                </h4>
                                <small class="text-muted">
                                  Due: {{ t.due_pretty || "—" }}
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-5">
                            <div
                              class="d-flex align-items-center justify-content-md-end flex-wrap row-gap-3"
                            >
                              <span
                                class="badge d-inline-flex align-items-center me-3"
                                :class="taskStatusBadgeClass(t.status)"
                              >
                                <i class="fas fa-circle fs-6 me-1"></i>
                                {{ t.status }}
                              </span>

                              <div class="d-flex align-items-center">
                                <div
                                  class="avatar-list-stacked avatar-group-sm"
                                >
                                  <span
                                    v-for="(av, i) in t.assignee_avatars"
                                    :key="i"
                                    class="avatar avatar-rounded"
                                  >
                                    <img
                                      class="border border-white"
                                      :src="
                                        av ||
                                        require('@/assets/img/profiles/avatar-13.jpg')
                                      "
                                      alt="img"
                                    />
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <button
                        class="btn bg-primary-transparent border-dashed border-primary w-100 text-start"
                        data-bs-toggle="modal"
                        data-bs-target="#add_todo"
                      >
                        <i class="ti ti-plus me-2"></i>New task
                      </button>
                    </div>

                    <div v-else class="text-muted">
                      No tasks linked to this project yet.
                    </div>
                  </div>
                </div>
              </div>

              <!-- IMAGES (placeholder, still static until you wire a files/images feature) -->
              <div class="accordion-item">
                <div class="accordion-header" id="headingImages">
                  <div class="accordion-button">
                    <div class="d-flex align-items-center flex-fill">
                      <h5>Images</h5>
                      <div class="ms-auto d-flex align-items-center">
                        <span class="badge bg-light text-dark me-3">Read only</span>
                        <a
                          href="javascript:void(0);"
                          class="d-flex align-items-center collapsed collapse-arrow"
                          data-bs-toggle="collapse"
                          data-bs-target="#imagesCollapse"
                          aria-expanded="false"
                          aria-controls="imagesCollapse"
                        >
                          <i class="ti ti-chevron-down fs-18"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="imagesCollapse"
                  class="accordion-collapse collapse show border-top"
                  aria-labelledby="headingImages"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p class="text-muted mb-0">
                      Project image uploads are not wired yet. This section is intentionally read-only until the files feature is implemented.
                    </p>
                  </div>
                </div>
                <div class="col-sm-3">
                  <p class="d-flex align-items-center mb-3">
                    <i class="ti ti-building-bank me-2"></i>Account
                  </p>
                </div>
                <div class="col-sm-9">
                  <div class="d-flex align-items-center mb-3">
                    <router-link
                      v-if="project.client_id"
                      :to="{ name: 'crm.clients.details', params: { id: project.client_id } }"
                      class="badge bg-light text-dark"
                    >
                      {{ project.client_name || "Linked account" }}
                    </router-link>
                    <span v-else class="badge bg-light text-muted">
                      No linked account
                    </span>
                  </div>
                </div>
              </div>

              <!-- FILES (placeholder) -->
              <div class="accordion-item">
                <div class="accordion-header" id="headingFiles">
                  <div class="accordion-button">
                    <div class="d-flex align-items-center flex-fill">
                      <h5>Files</h5>
                      <div class="ms-auto d-flex align-items-center">
                        <span class="badge bg-light text-dark me-3">Read only</span>
                        <a
                          href="javascript:void(0);"
                          class="d-flex align-items-center collapsed collapse-arrow"
                          data-bs-toggle="collapse"
                          data-bs-target="#filesCollapse"
                          aria-expanded="false"
                          aria-controls="filesCollapse"
                        >
                          <i class="ti ti-chevron-down fs-18"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="filesCollapse"
                  class="accordion-collapse collapse show border-top"
                  aria-labelledby="headingFiles"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p class="text-muted mb-0">
                      Project documents are not wired yet. This section stays visible so users can see the intended surface without fake upload actions.
                    </p>
                  </div>
                </div>
              </div>

              <!-- NOTES (placeholder) -->
              <div class="row">
                <div class="col-xl-6 d-flex">
                  <div class="accordion-item flex-fill">
                    <div class="accordion-header" id="headingNotes">
                      <div class="accordion-button">
                        <div class="d-flex align-items-center flex-fill">
                          <h5>Notes</h5>
                          <div class="ms-auto d-flex align-items-center">
                            <span class="badge bg-light text-dark me-3">Read only</span>
                            <a
                              href="javascript:void(0);"
                              class="d-flex align-items-center collapsed collapse-arrow"
                              data-bs-toggle="collapse"
                              data-bs-target="#notesCollapse"
                              aria-expanded="false"
                              aria-controls="notesCollapse"
                            >
                              <i class="ti ti-chevron-down fs-18"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="notesCollapse"
                      class="accordion-collapse collapse show border-top"
                      aria-labelledby="headingNotes"
                    >
                      <div class="accordion-body">
                        <p class="text-muted mb-0">
                          Project notes are not wired yet. The action has been disabled so this area no longer pretends to accept notes.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ACTIVITY (placeholder) -->
                <div class="col-xl-6 d-flex">
                  <div class="accordion-item flex-fill">
                    <div class="accordion-header" id="headingActivity">
                      <div class="accordion-button">
                        <div class="d-flex align-items-center flex-fill">
                          <h5>Activity</h5>
                          <div class="ms-auto d-flex align-items-center">
                            <span class="badge bg-light text-dark me-3">Read only</span>
                            <a
                              href="javascript:void(0);"
                              class="d-flex align-items-center collapsed collapse-arrow"
                              data-bs-toggle="collapse"
                              data-bs-target="#activityCollapse"
                              aria-expanded="false"
                              aria-controls="activityCollapse"
                            >
                              <i class="ti ti-chevron-down fs-18"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="activityCollapse"
                      class="accordion-collapse collapse show border-top"
                      aria-labelledby="headingActivity"
                    >
                      <div class="accordion-body">
                        <p class="text-muted mb-0">
                          Project activity logging is not wired yet. This placeholder is now read-only instead of exposing a dead-end action.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- INVOICES (placeholder) -->
              <div class="accordion-item">
                <div class="accordion-header" id="headingInvoices">
                  <div class="accordion-button">
                    <h5>Invoices</h5>
                    <div class="ms-auto d-flex align-items-center">
                      <a
                        href="javascript:void(0);"
                        class="d-flex align-items-center collapsed collapse-arrow"
                        data-bs-toggle="collapse"
                        data-bs-target="#invoicesCollapse"
                        aria-expanded="false"
                        aria-controls="invoicesCollapse"
                      >
                        <i class="ti ti-chevron-down fs-18"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  id="invoicesCollapse"
                  class="accordion-collapse collapse show border-top"
                  aria-labelledby="headingInvoices"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p class="text-muted mb-0">
                      Invoices linked to this project will appear here.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="alert alert-light border text-end mb-4">
              Secondary project features such as notes, files, activity logging, and invoices are visible here but remain read-only until their modules are fully wired.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useProjectStore } from "@/stores/projectStore";
import { useTaskStore } from "@/stores/taskStore";

const route = useRoute();
const projectStore = useProjectStore();
const taskStore = useTaskStore();

const loadingProject = ref(true);
const projectId = computed(() => Number(route.params.id));

const project = computed(() => {
  if (!projectId.value) return null;
  return projectStore.byId[projectId.value] || null;
});

const tasks = computed(() => taskStore.items || []);

/** Load project + tasks for this project */
onMounted(async () => {
  try {
    if (projectId.value) {
      await projectStore.ensureOne(projectId.value);
      await taskStore.list({ project_id: projectId.value, paginate: false });
    }
  } finally {
    loadingProject.value = false;
  }
});

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function formatDate(v) {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d)) return String(v).slice(0, 10);
  return d.toLocaleDateString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

const valueDisplay = computed(() => {
  if (!project.value || project.value.value == null) return "—";
  const num = Number(project.value.value);
  return isNaN(num) ? String(project.value.value) : num.toLocaleString();
});

const hoursDisplay = computed(() => {
  if (!project.value) return "—";
  const total = project.value.total_hours;
  const extra = project.value.extra_time;
  if (total && extra) return `${total}/${extra} Hrs`;
  if (total) return `${total} Hrs`;
  return "—";
});

const timeSpentLabel = computed(() => {
  if (!project.value) return "—";
  const total = project.value.total_hours;
  const extra = project.value.extra_time;
  if (total && extra) return `${total}/${extra} Hrs`;
  if (total) return `${total} Hrs`;
  return "—";
});

/** Priority badge classes */
const priorityBgClass = computed(() => {
  const p = project.value?.priority;
  if (p === "High") return "bg-transparent-danger";
  if (p === "Medium") return "bg-transparent-warning";
  if (p === "Low") return "bg-transparent-success";
  return "bg-transparent-secondary";
});

const priorityDotClass = computed(() => {
  const p = project.value?.priority;
  if (p === "High") return "text-danger";
  if (p === "Medium") return "text-warning";
  if (p === "Low") return "text-success";
  return "text-muted";
});

/** Status badge class for project */
const statusBadgeClass = computed(() => {
  const s = project.value?.status;
  if (s === "Active") return "badge-success";
  if (s === "Inactive") return "badge-danger";
  return "badge-secondary-transparent";
});

/** Task stats */
const taskStats = computed(() => {
  const total = tasks.value.length;
  const completed = tasks.value.filter((t) => t.status === "Completed").length;
  const percent = total ? Math.round((completed * 100) / total) : 0;
  return { total, completed, percent };
});

/** Overdue calculation */
const isOverdue = computed(() => {
  if (!project.value?.end_date) return false;
  const end = new Date(project.value.end_date);
  const today = new Date();
  if (isNaN(end)) return false;
  return end < new Date(today.toDateString()); // compare dates (ignore time)
});

const overdueDays = computed(() => {
  if (!isOverdue.value || !project.value?.end_date) return 0;
  const end = new Date(project.value.end_date);
  const today = new Date();
  const diff = today.setHours(0, 0, 0, 0) - end.setHours(0, 0, 0, 0);
  const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
  return days;
});

/** Task status badge class */
function taskStatusBadgeClass(status) {
  switch (status) {
    case "Onhold":
      return "bg-soft-pink";
    case "Inprogress":
      return "bg-transparent-purple";
    case "Completed":
      return "badge-soft-success";
    case "Pending":
    default:
      return "badge-secondary-transparent";
  }
}
</script>

<style scoped>
.project-description :deep(p) {
  margin-bottom: 0.5rem;
}
.project-description :deep(ul),
.project-description :deep(ol) {
  padding-left: 1.25rem;
}

@media (max-width: 767.98px) {
  .dq-page-actions {
    width: 100%;
    align-items: stretch !important;
    flex-direction: column;
    gap: 0.75rem;
  }

  .dq-page-actions .text-end,
  .dq-page-actions .btn {
    width: 100%;
  }

  .details-list-group .list-group-item > div,
  .details-list-group .list-group-item {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
}
</style>


